import {createContext, useContext, useEffect, useState} from "react";

const IsMobileContext = createContext();

export function IsMobileProvider({ children }) {
  const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 768px)").matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 767px)");

    const handleChange = (event) => {
      setIsMobile(event.matches);
    }

    mediaQuery.addEventListener("change", handleChange);
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  return (
    <IsMobileContext.Provider value={{ isMobile }}>
      { children }
    </IsMobileContext.Provider>
  );
}

export function useIsMobile() {
  const context = useContext(IsMobileContext);
  if (!context) {
    throw new Error("useIsMobile must be used within an IsMobileProvider");
  }

  return context.isMobile
}